import { Button, Input, Table } from "antd";
import { DownloadOutlined } from '@ant-design/icons';
import { BaseComponent, IBaseProps, IBaseStates } from "../../components/infrastructure/baseComponent";
import { IAttachment } from "./interfaces";
import { ColumnsType } from "antd/lib/table";

export interface IAttachmentDownloaderProps extends IBaseProps {
    attachments: IAttachment[];
    extraColumns?: () => any[];
}

export interface IAttachmentDownloaderStates extends IBaseStates {
}

export class AttachmentDownloader extends BaseComponent<IAttachmentDownloaderProps, IAttachmentDownloaderStates>{
    inputFile?: Input | null;
    constructor(props: IAttachmentDownloaderProps) {
        super(props)
        this.state = {
            isAuthorized: true,
            loading: true,
            windowSize: window.innerWidth <= 765 ? 1 : 2
        };
    }
    componentDidMount() {
        super.componentDidMount();
        this.setLoading(false);
    }
    virtualRender() {
        let columns: ColumnsType<any> = [
            //{
            //    title: 'نام فایل',
            //    dataIndex: 'Title',
            //    key: 'Title',
            //    render: (text: any, record: IAttachment, __: number) => {
            //        return <a href={record.Path} download={text}>{text}</a>;
            //    }
            //},
            {
                title: '',
                dataIndex: 'Path',
                key: 'Path',
                onHeaderCell: () => {
                    return {
                        style: { width: 30 }
                    }
                },
                onCell: () => {
                    return {
                        style: { padding: 2, textAlign: 'center' }
                    }
                },
                render: (_: any, record: IAttachment, __: number) => {
                    return (
                        <a href={record.Path} download={record.Title}>
                            <Button style={{ backgroundColor: 'transparent', border: 'none' }} icon={<DownloadOutlined />} size={"large"} title="دانلود"
                                onClick={(e) => {
                                    e.stopPropagation();
                                }}
                            />
                        </a>
                    )
                },
            }
        ];

        if (!this.props.extraColumns)
            columns = [{
                title: 'توضیحات',
                dataIndex: 'Description',
                key: 'Description',
            }, ...columns];
        
        if (this.props.extraColumns)
            columns.push(...this.props.extraColumns());

        let { attachments } = this.props;
        return (
            <>
                <Table
                    scroll={{ x: "max-content" }}
                    rowKey={a => a.RowGuid}
                    columns={columns}
                    dataSource={attachments.map(a => a)}
                    bordered
                />
            </>
        );
    }
}